import { fetchEmailSubscription, downloadEmailSubscriptionCsv } from '../services/napi';
import {
  EMAIL_SUBSCRIPTION_FETCH_SUCCESS,
  DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS
} from '../constant/actionType';

export function fetchEmailSubscriptions() {
  return async (dispatch, getState) => {
    try {
      const { _id: projectId } = getState().project.currentProject;
      const response = await fetchEmailSubscription(projectId);
      dispatch({
        data: response.data.emailSubscriptions,
        type: EMAIL_SUBSCRIPTION_FETCH_SUCCESS
      });
    } catch (error) {
      console.error(error);
    }
  };
}

export function downloadEmailSubscription() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await downloadEmailSubscriptionCsv(projectId);

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `emailSubscription.csv`);
    document.body.appendChild(link);
    link.click();

    dispatch({
      data: response.data,
      type: DOWNLOAD_EMAIL_SUBSCRIPTION_SUCCESS
    });
  };
}
